import type { OpenPosition } from "@/common/api/open-position/use-open-position-search.query";
import { DeviceType } from "@/common/hooks/use-device";
import type { ImplementedColumnDef } from "@/components/data-table/types";
import { FiaTrackingSource } from "@/modules/fia/fia.tracking";
import { openPositionColumns } from "@/modules/fia/open-position/positions/open-position-columns";
import { OpenPositionTable } from "@/modules/fia/open-position/positions/open-position-table";
import { useMemo } from "react";

const OPEN_POSITIONS_TAB_COLUMNS = [
  openPositionColumns.invoiceNumber,
  { ...openPositionColumns.type, visibility: [DeviceType.Tablet, DeviceType.Desktop, DeviceType.Widescreen] },
  openPositionColumns.amount,
  openPositionColumns.dueDate,
  { ...openPositionColumns.dunningLevel, visibility: [DeviceType.Desktop, DeviceType.Widescreen] },
  { ...openPositionColumns.dunningReason, visibility: [DeviceType.Tablet, DeviceType.Desktop, DeviceType.Widescreen] },
] as ImplementedColumnDef<OpenPosition, unknown>[];

export const OpenPositionsTab = ({ customerUuid }: { customerUuid: string }) => {
  const body = useMemo(() => ({ customer: [customerUuid] }), [customerUuid]);

  return (
    <OpenPositionTable
      name={`open-positions-${customerUuid}`}
      body={body}
      columns={OPEN_POSITIONS_TAB_COLUMNS}
      trackingSource={FiaTrackingSource.CustomerDetail}
    />
  );
};
